import { component } from 'picoapp';

export default component(async (node) => {
  const submitButton = node.querySelector('[data-submit]');
  const data = JSON.parse(node.dataset.variant);

  submitButton?.addEventListener('click', () => {
    const item = {
      id: data.id,
      quantity: 1,
      compare_at_price: data.compare_at_price,
      tags: data.tags,
    };
    document.dispatchEvent(new CustomEvent('cart:add:variant', { detail: { items: [item] } }));
  });
});
